import styled from 'styled-components';
import Button from '../../_shared/components/Button';

export const BoldText = styled.h1`
  margin: 16px 0 16px 0;
  padding: 0;
  font-size: ${({ theme }) => theme.FONT_SIZES.MEDIUM};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
`;

export const Divider = styled.div`
  border-top: 1px solid black;
`;

export const CheckBox = styled.input.attrs(() => ({
  type: 'checkbox'
}))`
  margin: 0px 8px 0px 0px;
`;

export const ModalContentWrapper = styled.div`
  width: 88%;
  margin: 30px auto;
`;

export const ModalOuterBoxContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const ModalOuterBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 900px;
  height: 'fit-content';
  background-color: ${({ theme }) => theme.COLORS.BASE};
  justify-content: center;
  position: absolute;
  z-index: 100;
  top: 150px;
`;

export const ModalSaveButtonWrapper = styled.div`
  margin-bottom: 16px;
`;

export const ModalSaveButton = styled(Button.Primary)`
  min-width: 104px;
  height: 36px;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  line-height: ${({ theme }) => theme.FONT_SIZES.SMALL};
  border-radius: 4px;
  position: inherit;
`;

export const StyledUl = styled.ul`
  padding-left: 15px;
  margin: 0;
`;

export const StyledLi = styled.li`
  list-style-position: outside;
  margin-left: 15px;
  list-style: disc;
`;

export const StyledDescription = styled.div`
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${({ theme }) => theme.FONT_SIZES.MEDIUM};
  line-height: ${({ theme }) => theme.FONT_SIZES.LARGE};
  margin: 0 0 20px 0;
`;

export const StyledLabel = styled.div`
  line-height: ${({ theme }) => theme.FONT_SIZES.LARGE}
  font-size: ${({ theme }) => theme.FONT_SIZES.MEDIUM};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_95};
  margin: 0 0 20px 0;
  display: inline-flex;
`;
